// Models
import Model from './Model'
import { SUBSCRIPTION_PLUS } from '@/models/Subscription'

class ClientRequest extends Model {
  get hasPremiumSubscriptionPriority () {
    return this.profile.subscription === SUBSCRIPTION_PLUS
  }

  get schema () {
    return [
      'createdAt',
      'creatorRole',
      'documents',
      'employee',
      'finishedAt',
      'hasAttachments',
      'id',
      'isLastMessageByAdmin',
      'isReadByAdmin',
      'locale',
      'messageCount',
      'messages',
      'payload',
      'profile',
      'requestMessage',
      'requestType',
      'service',
      'status',
      'subject',
      'updatedAt',
      'userEmail',
      'userId'
    ]
  }
}

export const CLIENT_REQUEST_TYPES = {
  OPEN_ACCOUNT_GBP: 'open-account-gbp',
  ADDITIONAL_CURRENT_ACCOUNT: 'additional-current-account',
  CLOSE_CURRENT_ACCOUNT: 'close-current-account',
  AUTO_ACCOUNT_CLOSURE: 'auto-account-closure',
  ACCOUNT_PAYMENT_CANCEL: 'account-payment-cancel',
  ACCOUNT_PAYMENT_INVESTIGATION: 'account-payment-investigation',
  SALARY_PROJECT: 'salary-project',
  ACCOUNT_OTHER: 'account-other',
  NEW_USER: 'new-user',
  DEPOSIT: 'deposit',
  SAVINGS_REPLENISHMENT: 'savings-replenishment',
  SAVINGS_WITHDRAWAL: 'savings-withdrawal',
  CURRENCY_CONVERSION: 'currency-conversion',
  ACCOUNT_TERMINATION: 'account-termination',
  STARTUP: 'startup',
  COMPLAINT: 'complaint'
}

export default ClientRequest
